import { useState } from "react";
import { Link } from "react-router-dom";
import { FREE_PRODUCT_LIMIT, PRO_PRICE, PRO_TRIAL_DAYS } from "../../plans";

const faqs = [
    ["¿El plan Gratis es gratis de verdad?", `Sí. Podés tener tu catálogo con QR y hasta ${FREE_PRODUCT_LIMIT} productos sin pagar nada y sin cargar tarjeta. Tu catálogo muestra la marca “Hecho con MiQRapp”.`],
    ["¿Mis clientes tienen que bajar una app?", "No. Escanean el QR con la cámara del celular o entran a tu link, y el catálogo se abre en el navegador."],
    ["¿Qué pasa si cambio los precios?", "Los cambiás desde tu cuenta y se ven al instante. El QR que ya imprimiste sigue funcionando igual."],
    ["¿Dónde descargo mi QR?", "En la configuración de tu cuenta, en cualquier plan. Lo podés imprimir y usar donde quieras."],
    ["¿Cómo funciona la prueba de Pro?", `Te suscribís con Mercado Pago y usás Pro ${PRO_TRIAL_DAYS} días sin cargo. Después se cobra ${PRO_PRICE} por mes de forma automática, sin permanencia mínima.`]
];

const LandingFAQ = () => {

    const [open, setOpen] = useState(0);

  return (
    <section className="lp-section">
        <div className="lp-container lp-faq">
            <h2 data-reveal>Preguntas frecuentes</h2>
            {
                faqs.map(([question, answer], i) => (
                    <div key={question} className="lp-faq-item" data-reveal style={{ "--d": (i * 60) + "ms" }}>
                        <button type="button" aria-expanded={open === i} onClick={() => setOpen(open === i ? -1 : i)}>
                            {question}
                            <span aria-hidden="true">{open === i ? "−" : "+"}</span>
                        </button>
                        <p hidden={open !== i}>{answer}</p>
                    </div>
                ))
            }
            <Link to="/preguntas-frecuentes" className="lp-text-link">Ver todas las preguntas</Link>
        </div>
    </section>
  )
}

export default LandingFAQ
